import { pdf } from '@react-pdf/renderer';
import moment from "moment";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Swal from 'sweetalert2';
import { actualizarAlertaLoading, cerrarAlerta, mostraAlertaError, mostraAlertaOk, mostrarAlertaLoading } from "../../../../componentes/alerts/sweetAlert";
import { cargarPorRangos, textoProgreso } from "../../../../componentes/datos/CargaPorRangos";
import { AxiosPrivado } from "../../../../componentes/axios/Axios";
import { ErroresPeticion } from "../../../../componentes/axios/ErroresPeticion";
import Card from "../../../../componentes/contenedores/Card";
import { IdentificarEstacion } from "../../../../componentes/estacion/Estacion";
import MetodosPagoDinamicos from "../../../../componentes/metodos/MetodosPagos";
import ModalBootstrap from "../../../../componentes/modal/ModalBootstrap";
import ModalWizardBootstrap from "../../../../componentes/modal/ModalWizardBootstrap";
import Page from "../../../../componentes/plantilla/Page";
import Tablas from "../../../../componentes/tablas/TablasGenerico";
import { CajaVerificar, VentaAnulada, VentaListar, VentaPagoAnulada, VentaListarId, ProductosListar } from "../../../../configuracion/apiUrls";
import { formatoMoneda } from "../../../../configuracion/validaciones";
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../../../contexto/usuario/UsuarioContext";
import { ImprimirVenta } from "./ImprimirVentas";
import ReporteVentas from "./ReporteVentas";
import { VentaFiltro } from "../../../../configuracion/apiUrls";
import { AxiosPublico } from '../../../../componentes/axios/Axios';


const HomeEditarVentas = () => {
    const { usuario } = useContextUsuario();
    const { ActualizarLista, listaClientes, setListaProductos, listaEmpleados } = useContextEmpleado();
    const refEdicion = useRef(null);
    const [ventaSeleccionada, setVentaSeleccionada] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalOpen2, setModalOpen2] = useState(false);
    const [descripcionAnulacion, setDescripcionAnulacion] = useState("");
    const [descripcionAnulacion2, setDescripcionAnulacion2] = useState("");
    const [efectivo, setEfectivo] = useState(0);
    const [totalRecibido, setTotalRecibido] = useState(0);
    const [pos, setPos] = useState(0);
    const [transferencias, setTransferencias] = useState(0);
    const [montosPos, setMontosPos] = useState({});
    const [referenciasPos, setReferenciasPos] = useState({});
    const [erroresReferenciaPos, setErroresReferenciaPos] = useState({});
    const [montosTransferencia, setMontosTransferencia] = useState({});
    const [referenciasTransferencia, setReferenciasTransferencia] = useState({});
    const [erroresReferenciaTransferencia, setErroresReferenciaTransferencia] = useState({});
    const [cajaId, setCajaId] = useState(null);
    const [cajaAbierta, setCajaAbierta] = useState(false);
    const [documentoFiltro, setDocumentoFiltro] = useState("FA");
    const [documentoFiltroTemp, setDocumentoFiltroTemp] = useState("FA");
    const [estadoFiltroTemp, setEstadoFiltroTemp] = useState("TODOS");
    const [panelAbierto, setPanelAbierto] = useState(false);
    const [fechaInicio, setFechaInicio] = useState(
        moment().startOf("isoWeek").format("YYYY-MM-DD")
    );
    const [fechaFin, setFechaFin] = useState(moment().format("YYYY-MM-DD"));
    const clientes = listaClientes || [];
    const [modalClienteOpen, setModalClienteOpen] = useState(false);
    const [clienteSearchTerm, setClienteSearchTerm] = useState("");
    const [selectedEvent, setSelectedEvent] = useState({});

    const [ventasFiltradas, setVentasFiltradas] = useState([]);
    const refCarga = useRef(null);

    // Al salir de la pantalla se cancela la carga en vuelo
    useEffect(() => {
        return () => {
            if (refCarga.current) {
                refCarga.current.abort();
            }
        };
    }, []);

    const fusionarDetalle = (anterior, detalle) => {
        const resultado = { ...anterior };
        Object.keys(detalle).forEach((clave) => {
            const valor = detalle[clave];
            if (valor !== undefined && valor !== null) {
                resultado[clave] = valor;
            }
        });
        return resultado;
    };

    const refrescarDetalleVenta = async (venta) => {
        if (!venta?.id) return;
        try {
            const { data } = await AxiosPrivado.get(VentaListarId + venta.id, {
                timeout: 20000,
            });
            const detalle = Array.isArray(data) ? data[0] : data;
            if (!detalle || !detalle.id) return;

            setVentaSeleccionada((previa) =>
                previa?.id === detalle.id ? fusionarDetalle(previa, detalle) : previa
            );
        } catch (error) {
            console.error("No se pudo refrescar el detalle de la venta:", error);
        }
    };


    const [empleadoFiltro, setEmpleadoFiltro] = useState(usuario?.datoPersonales?.id || "TODOS");
    const [empleadoFiltroTemp, setEmpleadoFiltroTemp] = useState("TODOS");

    const verificarYCargarCaja = async () => {
        try {
            const estacionDatos = await IdentificarEstacion();
            const response = await AxiosPrivado.post(CajaVerificar, { estacionDatos });
            if (response.data.estado === "CE") {
                mostraAlertaError("La caja ya está cerrada. No se puede registrar ventas.");
                return;
            }
            const caja = response.data;
            setCajaId(caja.id);
            setCajaAbierta(caja.estado !== "CE");
            return true;
            //mostraAlertaOk("Caja autenticada correctamente");
        } catch (error) {
            ErroresPeticion(error);
            //console.error("Autenticación de caja fallida:", error);
            return false;
        }
    };

    const [datosPago, setDatosPago] = useState({
        recibido: totalRecibido,
        tipoVenta: "Contado",
        documento: "FA",
        efectivo: [
            { monto: 500 }
        ],
        transferencia: [
            { monto: 1000, referencia: "900700027760", cuentaId: 1 }
        ],
        tarjeta: [
            { monto: 700, referencia: "900700027760", posId: 1 }
        ],
        montoCredito: 0,
        fecha: "",
        fechaVencimiento: "",
        saldo: 0,
    });

    useEffect(() => { 
        obtenerVentasFiltradas(documentoFiltroTemp, estadoFiltroTemp, empleadoFiltroTemp, selectedEvent?.clienteId, fechaInicio, fechaFin);
     }, []);

    const actualizarListaPagos = () => {
        let tipoPagoValido = "Efectivo";

        if (totalRecibido > 0) {
            if (parseFloat(efectivo) > 0 && transferencias === 0 && pos === 0) {
                tipoPagoValido = "Efectivo";
            } else if (transferencias > 0 && pos === 0) {
                tipoPagoValido = "Transferencia";
            } else if (pos > 0 && transferencias === 0) {
                tipoPagoValido = "Tarjeta";
            } else {
                tipoPagoValido = "Mixto";
            }
        }

        let tipoVenta = "Contado";
        if (datosPago.documento === "CR") {
            tipoVenta = "Crédito";
        }

        let nPago = {
            pago: Total,
            recibido: totalRecibido,
            tipo: tipoPagoValido,
            documento: datosPago.documento,
            tipoVenta: tipoVenta,
            fecha: moment().format("YYYY-MM-DD"),
            efectivo:
                parseFloat(efectivo) > 0 ? [{ monto: parseFloat(efectivo) }] : [],
        };

        const listaTransferencias = Object.keys(montosTransferencia)
            .filter(cuentaId => parseFloat(montosTransferencia[cuentaId] || 0) > 0)
            .map(cuentaId => ({
                monto: parseFloat(montosTransferencia[cuentaId]),
                referencia: referenciasTransferencia[cuentaId] || "",
                cuentaId: parseInt(cuentaId, 10),
            }));

        if (listaTransferencias.length > 0) {
            nPago = { ...nPago, transferencia: listaTransferencias };
        }

        const listaPos = Object.keys(montosPos)
            .filter(posId => parseFloat(montosPos[posId] || 0) > 0)
            .map(posId => ({
                monto: parseFloat(montosPos[posId]),
                referencia: referenciasPos[posId] || "",
                posId: parseInt(posId, 10),
            }));

        if (listaPos.length > 0) {
            nPago = { ...nPago, tarjeta: listaPos };
        }

        setDatosPago(nPago);
    };

    useEffect(() => {
        const nuevoTotal = parseFloat(pos) + parseFloat(transferencias) + parseFloat(efectivo);
        if (nuevoTotal !== totalRecibido) setTotalRecibido(nuevoTotal);
        actualizarListaPagos();
        verificarYCargarCaja();
    }, [pos, transferencias, efectivo]);

    const limpiarDatosPago = () => {
        setEfectivo(0);
        setTotalRecibido(0);
        setPos(0);
        setTransferencias(0);
        setMontosPos({});
        setReferenciasPos({});
        setErroresReferenciaPos({});
        setMontosTransferencia({});
        setReferenciasTransferencia({});
        setErroresReferenciaTransferencia({});
        setModalOpen(false);
        setModalOpen2(false);
        setDescripcionAnulacion2("");
        obtenerVentasFiltradas(documentoFiltro, estadoFiltroTemp, empleadoFiltro, selectedEvent?.clienteId, fechaInicio, fechaFin);
    };

    const handleSeleccionarVenta = (venta) => {
        setVentaSeleccionada(venta);
        setTimeout(() => {
            if (refEdicion.current) {
                refEdicion.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
        }, 100);
        refrescarDetalleVenta(venta);
    };

    const handleImprimirVenta = async (venta) => {
        if (!venta?.id) {
            mostraAlertaError("No se seleccionó una venta válida.", "Error");
            return;
        }

        const tieneDetalles = (venta.ventadetallepedidos && venta.ventadetallepedidos.length > 0) ||
                              (venta.ventaDetallePedidos && venta.ventaDetallePedidos.length > 0) ||
                              (venta.items && venta.items.length > 0);

        if (tieneDetalles && (venta.Cliente || venta.cliente)) {
            ImprimirVenta(venta);
            return;
        }

        mostrarAlertaLoading("Cargando comprobante...", "Obteniendo datos de la venta.");

        try {
            const response = await AxiosPrivado.get(VentaListarId + venta.id, {
                timeout: 8000,
            });
            const data = Array.isArray(response.data) ? response.data[0] : response.data;
            const ventaCompleta = { ...venta, ...(data || {}) };

            cerrarAlerta();
            if (document.body.classList.contains('swal2-shown')) {
                document.body.classList.remove('swal2-shown', 'swal2-height-auto');
            }
            setTimeout(() => {
                ImprimirVenta(ventaCompleta);
            }, 150);
        } catch (error) {
            cerrarAlerta();
            if (document.body.classList.contains('swal2-shown')) {
                document.body.classList.remove('swal2-shown', 'swal2-height-auto');
            }
            console.warn("Fallo al obtener datos adicionales de la venta, imprimiendo con datos locales:", error);
            ImprimirVenta(venta);
        }
    };


    const confirmarAnulacionVenta = async () => {
        mostrarAlertaLoading("Anulando venta...");
        if (!descripcionAnulacion.trim()) {
            mostraAlertaError(
                "Debe ingresar una descripción para la anulación.",
                "Error"
            );
            return;
        }
        try {
            await AxiosPrivado.post(VentaAnulada, {
                ventaId: ventaSeleccionada.id,
                fechaHora: moment().format("YYYY-MM-DDTHH:mm:ssZ"),
                estado: "Anulada",
                empleadoId: usuario.datoPersonales.id,
                descripcion: descripcionAnulacion,
            });
            mostraAlertaOk("Venta anulada correctamente.", "Éxito");
            ActualizarLista(ProductosListar, setListaProductos);
            setModalOpen(false);
            setDescripcionAnulacion("");
            setVentaSeleccionada(null);
            limpiarDatosPago();
            setTimeout(() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }, 100);
        } catch (er) {
            const { response } = er;
            ErroresPeticion(er);
            const msjError =
                response?.data?.msj ||
                response?.data?.error?.message ||
                "Ocurrió un error desconocido.";
            //mostraAlertaError(msjError, "Error");
        }
    };

    const Total = ventaSeleccionada?.totalVenta || 0;

    const validarPago = (esCredito, total, pos, trans, efectivo, recibido, pagos, pagoId) => {
        const totalTarjetaYTransf = pos + trans;
        if (!esCredito) {
            if (totalTarjetaYTransf > total) {
                mostraAlertaError("El monto pagado con tarjeta o transferencia no puede exceder el total de la compra.", "Pago inválido");
                return false;
            }
            const exceso = recibido - total;
            const efectivoRequerido = total - totalTarjetaYTransf;
            if (exceso > 0 && efectivo < efectivoRequerido) {
                mostraAlertaError("El cambio solo puede generarse si el exceso proviene del efectivo.", "Pago inválido");
                return false;
            }
        } else {
            const pagadoSinEste = pagos?.filter(p => p.estado !== "Anulada" && p.id !== pagoId)
                ?.reduce((sum, p) => sum + parseFloat(p.recibido || 0), 0) || 0;
            const saldoActual = total - pagadoSinEste;
            if (recibido > saldoActual) {
                if (totalTarjetaYTransf > saldoActual) {
                    mostraAlertaError("El monto pagado con tarjeta o transferencia no puede exceder el saldo pendiente.", "Pago inválido");
                    return false;
                }
                const exceso = recibido - saldoActual;
                const efectivoRequerido = saldoActual - totalTarjetaYTransf;
                if (efectivo < efectivoRequerido) {
                    mostraAlertaError("El cambio solo puede generarse si el exceso proviene del efectivo.", "Pago inválido");
                    return false;
                }
            }
        }
        return true;
    };

    const validarReferencias = () => {
        let hayError = false;
        let nuevosErroresPos = {};
        let nuevosErroresTransferencia = {};

        Object.keys(montosPos).forEach(posId => {
            if (parseFloat(montosPos[posId] || 0) > 0) {
                const ref = referenciasPos[posId] || "";
                if (!/^\d{6,15}$/.test(ref)) {
                    nuevosErroresPos[posId] = "La referencia debe tener entre 6 y 15 dígitos numéricos.";
                    hayError = true;
                }
            }
        });

        Object.keys(montosTransferencia).forEach(cuentaId => {
            if (parseFloat(montosTransferencia[cuentaId] || 0) > 0) {
                const ref = referenciasTransferencia[cuentaId] || "";
                if (!/^\d{8,15}$/.test(ref)) {
                    nuevosErroresTransferencia[cuentaId] = "La referencia debe tener entre 8 y 15 dígitos numéricos.";
                    hayError = true;
                }
            }
        });

        setErroresReferenciaPos(nuevosErroresPos);
        setErroresReferenciaTransferencia(nuevosErroresTransferencia);
        if (hayError) {
            mostraAlertaError("Hay referencias inválidas. Verifica los campos marcados.", "Error de validación");
        }
        return !hayError;
    };

    const generarListaTransferencias = () => {
        const lista = Object.keys(montosTransferencia)
            .filter(cuentaId => parseFloat(montosTransferencia[cuentaId] || 0) > 0)
            .map(cuentaId => ({
                monto: parseFloat(montosTransferencia[cuentaId]),
                referencia: referenciasTransferencia[cuentaId] || "",
                cuentaId: parseInt(cuentaId, 10),
            }));
        return lista;
    };

    const generarListaPos = () => {
        const lista = Object.keys(montosPos)
            .filter(posId => parseFloat(montosPos[posId] || 0) > 0)
            .map(posId => ({
                monto: parseFloat(montosPos[posId]),
                referencia: referenciasPos[posId] || "",
                posId: parseInt(posId, 10),
            }));
        return lista;
    };

    const confirmarAnulacionPago = async () => {
        mostrarAlertaLoading("Anulando pago...");
        if (!validarReferencias()) return;
        const esCredito = ventaSeleccionada?.creditos?.length > 0;
        const totalVenta = parseFloat(ventaSeleccionada?.totalVenta || 0);
        const efectivoNum = (datosPago.efectivo || []).reduce((acc, p) => acc + parseFloat(p.monto || 0), 0);
        const posNum = (datosPago.tarjeta || []).reduce((acc, p) => acc + parseFloat(p.monto || 0), 0);
        const transferenciaNum = (datosPago.transferencia || []).reduce((acc, p) => acc + parseFloat(p.monto || 0), 0);
        const totalRecibidoNum = efectivoNum + posNum + transferenciaNum;
        const totalElectronico = posNum + transferenciaNum;
        const saldoRequerido = saldoAntesDelUltimoPago;
        const pagoViejo = ultimoPago;
        const ventaId = ventaSeleccionada?.id;
        if (totalRecibidoNum <= 0) {
            mostraAlertaError("Debe ingresar al menos un método de pago válido.", "Error");
            return;
        }

        if (totalElectronico > saldoRequerido) {
            return mostraAlertaError(
                `La suma de tarjeta y transferencia no puede exceder el saldo pendiente.` + saldoRequerido > 0 ? ` Saldo pendiente: L. ${saldoRequerido.toFixed(2)}` : "",
                "Monto Inválido"
            );
        }

        if (totalRecibidoNum <= 0) {
            return mostraAlertaError(
                "Debe ingresar un monto mayor a cero.",
                "Monto Inválido"
            );
        }
        if (!cajaId) return mostraAlertaError("Caja no autenticada");
        // Para anular un pago la caja tiene que estar abierta. La condicion
        // anterior estaba invertida y, al no asignarse nunca la bandera,
        // nunca se disparaba: venia copiada de HomeApertura.
        if (!cajaAbierta) return mostraAlertaError("La caja no está abierta. No se puede anular el pago.");
        if (descripcionAnulacion2.trim().length < 10) return mostraAlertaError("Ingrese una descripción detallada del motivo de anulación.");
        if (pagoYaAnulado) return mostraAlertaError("Este pago ya fue anulado. No puede repetirse el proceso.");
        if (!pagoViejo?.id || !ventaId) return mostraAlertaError("No se encontró información válida del pago o compra.");
        // Validaciones por tipo de venta
        if (!validarPago(esCredito, totalVenta, posNum, transferenciaNum, efectivoNum, totalRecibidoNum, ventaSeleccionada?.pagos, pagoViejo.id)) {
            mostraAlertaError("La combinación de métodos de pago no es válida según el tipo de venta. Verifica los montos ingresados.", "Error");
            return;
        }
        // Crear nuevo pago
        const nuevoPago = {
            fecha: moment().toISOString(),
            pago: totalRecibidoNum,
            recibido: totalRecibidoNum,
            documento: pagoViejo.documento,
            cajaId,
            ventaId,
            estado: "Completada",
            efectivo: efectivoNum,
            transferencia: generarListaTransferencias(),
            tarjeta: generarListaPos()
        };
        try {
            await AxiosPrivado.post(VentaPagoAnulada, {
                pagoId: pagoViejo.id,
                fechaHora: moment().format("YYYY-MM-DDTHH:mm:ssZ"),
                empleadoId: usuario.datoPersonales.id,
                descripcion: descripcionAnulacion2,
                pago: nuevoPago,
            });
            mostraAlertaOk("Pago anulado y reemplazado correctamente.");
            //console.log("Pago anulado y reemplazado:", nuevoPago);
            setVentaSeleccionada(null);
            setModalOpen(false);
            limpiarDatosPago();
            window.scrollTo({ top: 0, behavior: "smooth" });
        } catch (error) {
            const msjError =
                error?.response?.data?.msj ||
                error?.response?.data?.error?.message ||
                "Ocurrió un error desconocido.";
            mostraAlertaError(msjError);
        }
    };

    const handleImprimirReporteVentas = async (venta) => {
        if (!venta?.id) {
            mostraAlertaError("No se encontraron detalles para generar el reporte.", "Error");
            return;
        }

        mostrarAlertaLoading("Generando PDF...", "Preparando reporte de venta.");

        try {
            let ventaCompleta = venta;
            const tieneDetalles = (venta.ventadetallepedidos && venta.ventadetallepedidos.length > 0) ||
                                  (venta.ventaDetallePedidos && venta.ventaDetallePedidos.length > 0) ||
                                  (venta.items && venta.items.length > 0);

            if (!tieneDetalles || (!venta.Cliente && !venta.cliente)) {
                try {
                    const response = await AxiosPrivado.get(VentaListarId + venta.id, { timeout: 8000 });
                    const data = Array.isArray(response.data) ? response.data[0] : response.data;
                    if (data && data.id) {
                        ventaCompleta = { ...venta, ...data };
                    }
                } catch (e) {
                    console.warn("No se pudo obtener detalle adicional, generando con datos existentes.");
                }
            }

            const blob = await pdf(<ReporteVentas venta={ventaCompleta} />).toBlob();
            cerrarAlerta();
            if (document.body.classList.contains('swal2-shown')) {
                document.body.classList.remove('swal2-shown', 'swal2-height-auto');
            }

            const url = URL.createObjectURL(blob);
            const win = window.open(url, "_blank");
            if (!win) {
                const a = document.createElement("a");
                a.href = url;
                a.download = `Reporte_Venta_${venta.id}.pdf`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
            setTimeout(() => URL.revokeObjectURL(url), 15000);
        } catch (error) {
            cerrarAlerta();
            if (document.body.classList.contains('swal2-shown')) {
                document.body.classList.remove('swal2-shown', 'swal2-height-auto');
            }
            console.error("Error al generar el PDF:", error);
            mostraAlertaError("No se pudo generar el reporte en PDF. Inténtelo de nuevo.", "Error");
        }
    };

    const columnas = useMemo(
        () => [
            {
                title: "ID",
                data: null,
                render: (row) => {
                    const factura = row.facturaNumero || row.numeroFactura || row.facturas?.[0]?.numeroFactura;
                    const recibo = row.reciboNumero || row.reciboId || row.recibos?.[0]?.id;
                    const credito = row.creditoId || row.creditos?.[0]?.id;

                    return `
                        <div class="fw-semibold">#${row.id}</div>
                        ${factura ? `<span class="badge bg-primary">FA ${factura}</span>` : ""}
                        ${recibo ? `<span class="badge bg-info">RC ${recibo}</span>` : ""}
                        ${credito ? `<span class="badge bg-warning text-dark">CR ${credito}</span>` : ""}
                    `;
                }
            },
            {
                title: "Fecha",
                data: null,
                render: (row) => {
                    const fechaStr =
                        row.fecha ||
                        row.createdAt ||
                        row.facturas?.[0]?.fecha ||
                        row.recibos?.[0]?.fecha ||
                        row.creditos?.[0]?.fecha;

                    if (!fechaStr) {
                        return '<span class="text-muted">—</span>';
                    }

                    const fecha = moment(fechaStr);

                    if (!fecha.isValid()) {
                        return '<span class="text-danger">Fecha inválida</span>';
                    }

                    return `
                        <div>${fecha.format("DD/MM/YYYY")}</div>
                        <small class="text-muted">${fecha.format("HH:mm")}</small>
                    `;
                },
            },
            {
                title: "Cliente",
                data: null,
                render: (row) => {
                    const cliente = row.Cliente;
                    const clienteNombre = row.clienteNombre || cliente?.nombreCompleto;
                    const empresa = cliente?.ClienteEmpresas?.[0];
                    const nombre = empresa?.nombre || clienteNombre || "Sin cliente";
                    const rtn = row.rtn || cliente?.rtn || empresa?.rtn;

                    return `
                        <div class="fw-semibold">
                            ${nombre}
                        </div>
                        ${rtn ? `<div class="small text-muted">RTN: ${rtn}</div>` : ""}
                        ${empresa && clienteNombre ? `<div class="small text-secondary">${clienteNombre}</div>` : ""}
                    `;
                },
            },
            {
                title: "Vendedor",
                data: null,
                render: (dataRow) => {
                    const vendedor = dataRow.empleadoNombre || dataRow.Empleado?.nombreCompleto || "Sin vendedor";
                    const cajaNombre = dataRow.cajaNombre || dataRow.caja?.nombre;
                    const cajaDispositivo = dataRow.cajaDispositivo || dataRow.caja?.estacione?.dispositivo;
                    return `
                        <div>
                            <div class="fw-bold text-dark">
                                ${vendedor}
                            </div>
                            ${cajaNombre ? `
                                <div class="small text-muted">
                                    Caja: ${cajaNombre}
                                </div>
                                <div class="small text-muted">
                                    Dispositivo: ${cajaDispositivo || "-"}
                                </div>
                            ` : ""}
                        </div>
                    `;
                },
            },
            {
                title: "Tipo Venta",
                data: null,
                render: (row) => {
                    const esCredito = row.tieneCredito ?? (row.creditoId != null || (Array.isArray(row.creditos) && row.creditos.length > 0) || row.tipoVenta === "Credito");
                    const documento = (row.tieneFactura || row.facturaNumero || row.numeroFactura || row.facturas?.length > 0)
                        ? "Factura"
                        : (row.tieneRecibo || row.reciboNumero || row.reciboId || row.recibos?.length > 0)
                            ? "Recibo"
                            : null;

                    return `
                        <div>
                            ${documento ? `<div>${documento}</div>` : ""}
                            <div>
                                ${esCredito ? '<span class="badge bg-warning">Crédito</span>' : '<span class="badge bg-success">Contado</span>'}
                            </div>
                        </div>
                    `;
                },
            },
            {
                title: "Estado",
                data: "estado",
                render: (data) => {
                    let badgeClass = "";
                    switch (data) {
                        case "Completada":
                            badgeClass = "bg-success text-white";
                            break;
                        case "Anulada":
                            badgeClass = "bg-info text-white";
                            break;
                        case "Pendiente":
                            badgeClass = "bg-warning text-dark";
                            break;
                        default:
                            badgeClass = "bg-secondary text-white";
                    }
                    return `<span class="badge ${badgeClass}">${data}</span>`;
                },
            },
            {
                title: "Total (L)",
                data: "totalVenta",
                render: (data) => {
                    const valorFormateado = formatoMoneda(data);
                    return `<span style="text-align: right; display: block;">${valorFormateado}</span>`;
                }
            },
            {
                title: "Acciones",
                data: null,
                orderable: false,
                className: "dt-center all",
                actions: [
                    {
                        key: "ver",
                        className: "btn btn-outline-primary btn-sm",
                        icon: "fas fa-eye",
                        title: "Ver Detalles",
                        onClick: (rowData) => handleSeleccionarVenta(rowData)
                    },
                    {
                        key: "imprimir",
                        className: "btn btn-outline-info btn-sm",
                        icon: "fas fa-print",
                        title: "Imprimir",
                        onClick: (rowData) => handleImprimirVenta(rowData)
                    },
                    {
                        key: "imprimirReporteVentas",
                        className: "btn btn-outline-success btn-sm my-1",
                        icon: "fas fa-chart-bar",
                        title: "Reporte de Venta",
                        onClick: (rowData) => handleImprimirReporteVentas(rowData)
                    }
                ]
            }
        ],
        []
    );

    const datos = {
        titulo: {
            titulo: "Gestion de ventas",
            url: "/app/admin/ventas/gestionar",
            tituloUrl: "Menu gestion",
            nombreUrl: "Edición",
        },
    };

    const filtrarPorDocumento = useCallback((ventas, documento) => {
        if (documento === "TODOS") return ventas || [];
        return (ventas || []).filter((v) => {
            if (documento === "FA") {
                return v.tieneFactura ?? (v.facturaNumero != null || v.numeroFactura != null || (Array.isArray(v.facturas) && v.facturas.length > 0));
            }
            if (documento === "RE") {
                return v.tieneRecibo ?? (v.reciboNumero != null || v.reciboId != null || (Array.isArray(v.recibos) && v.recibos.length > 0));
            }
            if (documento === "CR") {
                return v.tieneCredito ?? (v.creditoId != null || (Array.isArray(v.creditos) && v.creditos.length > 0) || v.tipoVenta === "Credito");
            }
            return false;
        });
    }, []);

    const obtenerVentasFiltradas = async (
        documento,
        estado,
        empleado,
        clienteId,
        finicio,
        ffin
    ) => {
        if (refCarga.current) {
            refCarga.current.abort();
        }
        const control = new AbortController();
        refCarga.current = control;

        const desde = finicio || moment().startOf("isoWeek").format("YYYY-MM-DD");
        const hasta = ffin || moment().format("YYYY-MM-DD");

        mostrarAlertaLoading("Obteniendo ventas", "Preparando la consulta.");

        try {
            await cargarPorRangos({
                url: VentaFiltro,
                familia: "ventas",
                filtros: {
                    clienteId: clienteId || "",
                    empleadoId: empleado && empleado !== "TODOS" ? empleado : "",
                    estado: estado && estado !== "TODOS" ? estado : "",
                },
                desde,
                hasta,
                signal: control.signal,
                onLote: (acumulado, info) => {
                    setVentasFiltradas(filtrarPorDocumento(acumulado, documento));
                    actualizarAlertaLoading(textoProgreso(info));
                },
            });

            cerrarAlerta();
        } catch (error) {
            if (
                error.name === "CanceledError" ||
                error.code === "ERR_CANCELED" ||
                control.signal.aborted
            ) {
                return;
            }

            console.error(error);
            const esTimeout =
                error.code === "ECONNABORTED" ||
                (error.message || "").toLowerCase().includes("timeout");
            mostraAlertaError(
                esTimeout
                    ? "La consulta tardó demasiado. Reduzca el rango de fechas e intente de nuevo."
                    : "Error al obtener las ventas.",
                "Error"
            );
            setVentasFiltradas([]);
        } finally {
            if (refCarga.current === control) {
                refCarga.current = null;
            }
        }
    };

    const filteredClientes = clientes.filter((cliente) => {
        const searchTerm = clienteSearchTerm.trim().toLowerCase();

        // 1. Búsqueda por Nombre Completo del Cliente
        const nombreClienteMatch = cliente.nombreCompleto
            .toLowerCase()
            .includes(searchTerm);

        // 2. Búsqueda por Nombre de la Empresa del Cliente
        const nombreEmpresaMatch =
            cliente.ClienteEmpresas &&
            cliente.ClienteEmpresas.some((empresa) =>
                empresa.nombre.toLowerCase().includes(searchTerm)
            );

        // El cliente se incluye si coincide por nombre completo O por el nombre de alguna de sus empresas
        return nombreClienteMatch || nombreEmpresaMatch;
    });

    const handleClienteSeleccionado = (cliente) => {
        setSelectedEvent((prev) => ({
            ...prev,
            clienteId: cliente.id,
            clienteNombre: cliente.nombreCompleto,
        }));
        setModalClienteOpen(false);
    };

    const handleFiltrar = () => {
        setDocumentoFiltro(documentoFiltroTemp);
        setEmpleadoFiltro(empleadoFiltroTemp);
        setPanelAbierto(false);
        obtenerVentasFiltradas(documentoFiltroTemp, estadoFiltroTemp, empleadoFiltroTemp, selectedEvent?.clienteId, fechaInicio, fechaFin);
    };

    const handleReset = () => {
        setFechaInicio(moment().startOf("isoWeek").format("YYYY-MM-DD"));
        setFechaFin(moment().format("YYYY-MM-DD"));
        setSelectedEvent({});

        setEmpleadoFiltro("TODOS");
        setEmpleadoFiltroTemp("TODOS");

        setDocumentoFiltro("FA");
        setDocumentoFiltroTemp("FA");
        setEstadoFiltroTemp("TODOS");
        setPanelAbierto(false);
        obtenerVentasFiltradas("FA", "TODOS", "TODOS", null, moment().startOf("isoWeek").format("YYYY-MM-DD"), moment().format("YYYY-MM-DD"));
    };

    const ultimoPago = useMemo(() => {
        if (!ventaSeleccionada) return null;
        return ventaSeleccionada.pagoVenta
            ?.filter(pv => pv.pago?.estado !== "Anulada" && parseFloat(pv.pago?.recibido) > 0)
            ?.map(pv => pv.pago)
            ?.sort((a, b) => new Date(b.fecha) - new Date(a.fecha))[0];
    }, [ventaSeleccionada]);

    const pagoYaAnulado = useMemo(() => {
        const pagos = ventaSeleccionada?.pagoVenta ?? [];

        const penultimoPago =
            pagos.length >= 2
                ? pagos[pagos.length - 2]
                : null;

        return penultimoPago?.pago?.estado === "Anulada";
    }, [ventaSeleccionada]);

    const pagosValidos = useMemo(() => {
        if (!ventaSeleccionada) return [];
        return ventaSeleccionada.pagoVenta
            ?.filter(pv => pv.pago?.estado !== "Anulada")
            ?.map(pv => pv.pago)
            ?.sort((a, b) => new Date(a.fecha) - new Date(b.fecha)) || [];
    }, [ventaSeleccionada]);

    const totalVenta = useMemo(() => {
        return parseFloat(ventaSeleccionada?.totalVenta || 0);
    }, [ventaSeleccionada]);

    const saldoAntesDelUltimoPago = useMemo(() => {
        if (pagosValidos.length > 1) {
            const pagosSinUltimo = pagosValidos.slice(0, -1);
            const acumuladoSinUltimo = pagosSinUltimo.reduce(
                (sum, p) => sum + parseFloat(p.recibido || 0),
                0
            );
            return totalVenta - acumuladoSinUltimo;
        } else if (pagosValidos.length === 1) {
            return totalVenta;
        }
        return totalVenta;
    }, [pagosValidos, totalVenta]);

    const esVentaCredito = useMemo(() => ventaSeleccionada?.creditos?.length > 0, [ventaSeleccionada]);

    const calcularCambio = useMemo(() => {
        const recibidoNuevo =
            parseFloat(efectivo || 0) +
            parseFloat(pos || 0) +
            parseFloat(transferencias || 0);

        // Si es venta a crédito, el cambio siempre es 0 (solo se registra abono).
        if (esVentaCredito) {
            return 0;
        }

        // Si es venta al contado, calcula el cambio si el monto recibido supera el saldo.
        return Math.max(recibidoNuevo - saldoAntesDelUltimoPago, 0);

    }, [efectivo, pos, transferencias, saldoAntesDelUltimoPago, esVentaCredito]);

    const [paginaCliente, setPaginaCliente] = useState(1);
    const clientesPorPagina = 5;
    const indexUltimoCliente = paginaCliente * clientesPorPagina;
    const indexPrimeroCliente = indexUltimoCliente - clientesPorPagina;
    const clientesPagina = filteredClientes.slice(indexPrimeroCliente, indexUltimoCliente);
    const totalPaginasCliente = Math.ceil(filteredClientes.length / clientesPorPagina);

    const obtenerLineasDePagoDetalladas = (pagoVentaItem, indice) => {
        const lineas = [];

        const datosBase = {
            fecha: pagoVentaItem.pago.fecha,
            documento: pagoVentaItem.pago.documento || `Abono #${indice + 1}`,
            pagoId: pagoVentaItem.pago.id,
        };

        let detalleEncontrado = false;

        pagoVentaItem.pago.pagoefectivos?.forEach((efectivo, idx) => {
            detalleEncontrado = true;
            const cambio = parseFloat(pagoVentaItem.pago.recibido || 0) - parseFloat(pagoVentaItem.pago.pago || 0);
            lineas.push({
                ...datosBase,
                key: `${pagoVentaItem.pago.id}-efectivo-${idx}`,
                metodo: "Efectivo",

                // dinero recibido del cliente
                monto: parseFloat(efectivo.monto || 0),

                // dinero aplicado a la venta
                aplicado: parseFloat(efectivo.monto - cambio || 0),

                // cambio entregado
                cambio: cambio,

                cssClass: "text-success",
            });
        });

        pagoVentaItem.pago.pagotarjeta?.forEach((tarjeta, idx) => {
            detalleEncontrado = true;

            lineas.push({
                ...datosBase,
                key: `${pagoVentaItem.pago.id}-tarjeta-${idx}`,
                metodo: "Tarjeta",
                monto: parseFloat(tarjeta.monto || 0),
                aplicado: parseFloat(tarjeta.monto || 0),
                cambio: 0,
                cssClass: "text-info",
            });
        });

        pagoVentaItem.pago.pagotransferencia?.forEach((transferencia, idx) => {
            detalleEncontrado = true;

            lineas.push({
                ...datosBase,
                key: `${pagoVentaItem.pago.id}-transferencia-${idx}`,
                metodo: "Transferencia",
                monto: parseFloat(transferencia.monto || 0),
                aplicado: parseFloat(transferencia.monto || 0),
                cambio: 0,
                cssClass: "text-primary",
            });
        });

        const montoPagoPrincipal = parseFloat(
            pagoVentaItem.pago.recibido || 0
        );

        if (!detalleEncontrado && montoPagoPrincipal > 0) {
            lineas.push({
                ...datosBase,
                key: `${pagoVentaItem.pago.id}-general`,
                metodo: "Pago General",
                monto: montoPagoPrincipal,
                cssClass: "text-warning",
            });
        }

        return lineas;
    };

    const todasLasLineasDePago =
        ventaSeleccionada?.pagoVenta
            ?.filter(item => item.pago?.estado !== "Anulada")
            .sort(
                (a, b) =>
                    new Date(a.pago.fecha) -
                    new Date(b.pago.fecha)
            )
            .flatMap((item, indice) =>
                obtenerLineasDePagoDetalladas(item, indice)
            ) || [];

    const documentoInfo = (() => {
        if (ventaSeleccionada?.facturas?.length > 0) {
            return {
                tipo: "Factura",
                numero: ventaSeleccionada?.facturas[0].numeroFactura,
                badge: "bg-primary"
            };
        }

        if (ventaSeleccionada?.recibos?.length > 0) {
            return {
                tipo: "Recibo",
                numero: ventaSeleccionada?.recibos[0].id,
                badge: "bg-info"
            };
        }

        return null;
    })();

    return (
        <Page datos={datos}>
            <Card>
                <div className="mb-4 d-flex justify-content-end">
                    <div className="position-relative">
                        {/* Botón para Abrir/Cerrar Panel */}
                        <button
                            className={`btn ${panelAbierto ? "btn-danger" : "btn-primary"} d-flex justify-content-between align-items-center`}
                            onClick={() => setPanelAbierto(!panelAbierto)}
                            style={{
                                borderRadius: "6px",
                                padding: "6px 12px",
                                fontSize: "0.9rem",
                                minWidth: "140px",
                            }}
                        >
                            <span className="d-flex align-items-center">
                                <i className="fas fa-filter mx-2"></i>
                                Filtros
                            </span>
                            <i className={`fas fa-chevron-${panelAbierto ? "up" : "down"}`}></i>
                        </button>

                        {/* Panel de Filtros */}
                        {panelAbierto && (
                            <div
                                className="position-absolute top-100 mt-2 bg-body border border-secondary-subtle text-body shadow"
                                style={{
                                    minWidth: "240px",
                                    right: 0,
                                    borderRadius: "10px",
                                    backgroundColor: "#fff",
                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                    padding: "15px",
                                    zIndex: 1050,
                                }}
                            >
                                <div className="mb-3">
                                    <label className="form-label">Fecha inicio</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        value={fechaInicio}
                                        onChange={(e) => setFechaInicio(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Fecha fin</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        value={fechaFin}
                                        onChange={(e) => setFechaFin(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Cliente</label>
                                    <div className="d-flex align-items-center">
                                        {selectedEvent.clienteNombre ? (
                                            <span className="text-success fw-bold">{selectedEvent.clienteNombre}</span>
                                        ) : (
                                            <span className="text-muted">Ninguno seleccionado</span>
                                        )}
                                    </div>
                                    <ModalBootstrap
                                        titulo="Seleccionar cliente"
                                        nombreBoton="Buscar"
                                        estiloBoton="btn btn-sm btn-outline-primary mt-2"
                                        iconBoton="fa-solid fa-magnifying-glass"
                                        modalIsOpen={modalClienteOpen}
                                        setModalIsOpen={setModalClienteOpen}
                                    >
                                        <div className="mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Buscar cliente..."
                                                value={clienteSearchTerm}
                                                onChange={(e) => setClienteSearchTerm(e.target.value)}
                                            />
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-striped table-hover shadow-smr">
                                                <thead className="bg-dark text-white">
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Empresas</th>
                                                        <th>Nombre completo</th>
                                                        <th>Agregar</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {clientesPagina.length > 0 ? (
                                                        clientesPagina.map((cliente) => (
                                                            <tr key={cliente.id}>
                                                                <td>{cliente.id}</td>
                                                                <td className="align-middle">
                                                                    {cliente.ClienteEmpresas && cliente.ClienteEmpresas.length > 0
                                                                        ? cliente.ClienteEmpresas.map((empresa, index) => (
                                                                            <div key={index} className="mb-1">
                                                                                {empresa.nombre}
                                                                            </div>
                                                                        ))
                                                                        : "N/A"}
                                                                </td>
                                                                <td>{cliente.nombreCompleto}</td>
                                                                <td className="text-center align-middle">
                                                                    <button
                                                                        className="btn btn-success btn-sm"
                                                                        onClick={() =>
                                                                            handleClienteSeleccionado(cliente)
                                                                        }
                                                                    >
                                                                        <i className="fa-regular fa-square-check" />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="3" className="text-center text-muted">
                                                                No se encontraron clientes.
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                            <div className="d-flex justify-content-center">
                                                <nav className="mt-2">
                                                    <ul className="pagination pagination-sm justify-content-center shadow-sm bg-light p-3 rounded">
                                                        {/* Botón "Anterior" */}
                                                        <li className={`page-item ${paginaCliente === 1 ? "disabled" : ""}`}>
                                                            <button
                                                                className="page-link"
                                                                onClick={() => setPaginaCliente(paginaCliente - 1)}
                                                                aria-label="Anterior"
                                                            >
                                                                <i className="fas fa-chevron-left me-1"></i> Anterior
                                                            </button>
                                                        </li>

                                                        {
                                                            (() => {
                                                                const pagesToShow = 5;
                                                                const halfPages = Math.floor(pagesToShow / 2);
                                                                let startPage = Math.max(1, paginaCliente - halfPages);
                                                                let endPage = Math.min(totalPaginasCliente, paginaCliente + halfPages);

                                                                if (paginaCliente <= halfPages) {
                                                                    endPage = Math.min(totalPaginasCliente, pagesToShow);
                                                                }
                                                                if (paginaCliente > totalPaginasCliente - halfPages) {
                                                                    startPage = Math.max(1, totalPaginasCliente - pagesToShow + 1);
                                                                }

                                                                const pageButtons = [];
                                                                for (let i = startPage; i <= endPage; i++) {
                                                                    pageButtons.push(
                                                                        <li
                                                                            key={i}
                                                                            className={`page-item ${paginaCliente === i ? "active" : ""}`}
                                                                        >
                                                                            <button className="page-link fw-bold" onClick={() => setPaginaCliente(i)}>
                                                                                {i}
                                                                            </button>
                                                                        </li>
                                                                    );
                                                                }
                                                                return pageButtons;
                                                            })()
                                                        }

                                                        {/* Botón "Siguiente" */}
                                                        <li className={`page-item ${paginaCliente === totalPaginasCliente ? "disabled" : ""}`}>
                                                            <button
                                                                className="page-link"
                                                                onClick={() => setPaginaCliente(paginaCliente + 1)}
                                                                aria-label="Siguiente"
                                                            >
                                                                Siguiente <i className="fas fa-chevron-right ms-1"></i>
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>
                                    </ModalBootstrap>
                                </div>
                                {/* Filtro de Documento */}
                                <div className="form-group mb-3">
                                    <label htmlFor="documentoFiltroSelect" className="form-label fw-bold">Documento</label>
                                    <select
                                        id="documentoFiltroSelect"
                                        className="form-control form-control-sm"
                                        // *** Se vincula al estado TEMPORAL ***
                                        value={documentoFiltroTemp}
                                        onChange={(e) => setDocumentoFiltroTemp(e.target.value)}
                                    >
                                        {/* El primer valor es Facturas (el valor por defecto) */}
                                        <option value="FA">Facturas</option>
                                        <option value="RE">Recibos</option>
                                        <option value="CR">Créditos</option>
                                        <option value="TODOS">Todos</option>
                                    </select>
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="estadoFiltroSelect" className="form-label fw-bold">Estado</label>
                                    <select
                                        id="estadoFiltroSelect"
                                        className="form-control form-control-sm"
                                        value={estadoFiltroTemp}
                                        onChange={(e) => setEstadoFiltroTemp(e.target.value)}
                                    >
                                        <option value="TODOS">Todos</option>
                                        <option value="Completada">Completada</option>
                                        <option value="Anulada">Anulada</option>
                                    </select>
                                </div>
                                <div className="form-group mb-3">
                                    <label className="form-label fw-bold">
                                        Empleado
                                    </label>

                                    <select
                                        className="form-control form-control-sm"
                                        value={empleadoFiltroTemp}
                                        onChange={(e) =>
                                            setEmpleadoFiltroTemp(e.target.value)
                                        }
                                    >
                                        <option value="TODOS">
                                            Todas las ventas
                                        </option>

                                        {listaEmpleados?.map((empleado) => (
                                            <option
                                                key={empleado.id}
                                                value={empleado.id}
                                            >
                                                {empleado.nombreCompleto}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Botones de Acción */}
                                <div className="d-flex justify-content-end">
                                    {/* *** Aplica el filtro con el valor temporal *** */}
                                    <button className="btn btn-sm btn-primary mx-2" onClick={handleFiltrar}>
                                        <i className="fas fa-filter mx-1"></i> Filtrar
                                    </button>
                                    {/* *** Resetea a Facturas *** */}
                                    <button className="btn btn-sm btn-secondary" onClick={handleReset}>
                                        <i className="fas fa-sync-alt mx-1"></i> Reset
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <Tablas
                    datos={ventasFiltradas}
                    columnas={columnas}
                    id="tablaVentasFiltradas"
                />
            </Card>
            {ventaSeleccionada && (
                <div ref={refEdicion}>
                    <Card
                        titulo={`Detalles de la venta #${ventaSeleccionada.id}`}
                        pie={
                            <>
                                {!(ventaSeleccionada.ventanuladas && ventaSeleccionada.ventanuladas.length > 0) ? (
                                    <ModalBootstrap
                                        titulo={`Anular Venta #${ventaSeleccionada?.id || "..."}`}
                                        modalIsOpen={modalOpen}
                                        setModalIsOpen={setModalOpen}
                                        nombreBoton="Anular venta"
                                        estiloBoton="btn btn-danger"
                                        iconBoton="fas fa-ban"
                                        pie={
                                            <button className="btn btn-warning" onClick={confirmarAnulacionVenta}>
                                                Confirmar
                                            </button>
                                        }
                                    >
                                        <div className="mb-3">
                                            <label className="form-label fw-bold">Motivo de anulación</label>
                                            <textarea
                                                className="form-control"
                                                rows="3"
                                                value={descripcionAnulacion}
                                                onChange={(e) => setDescripcionAnulacion(e.target.value)}
                                            />
                                        </div>
                                    </ModalBootstrap>
                                ) : (

                                    <div className="card border-danger shadow-sm mt-3">

                                        <div className="card-header bg-danger text-white">

                                            <div className="d-flex align-items-center">

                                                <i className="fas fa-ban mr-2"></i>

                                                <strong>
                                                    Venta Anulada
                                                </strong>

                                            </div>

                                        </div>

                                        <div className="card-body">

                                            <div className="row">

                                                <div className="col-md-6 mb-3">

                                                    <small className="text-muted d-block">
                                                        Motivo de Anulación
                                                    </small>

                                                    <div className="font-weight-bold">
                                                        {
                                                            ventaSeleccionada.ventanuladas[0]
                                                                .descripcion
                                                        }
                                                    </div>

                                                </div>

                                                <div className="col-md-6 mb-3">

                                                    <small className="text-muted d-block">
                                                        Responsable
                                                    </small>

                                                    <div className="font-weight-bold">
                                                        {
                                                            ventaSeleccionada.ventanuladas[0]
                                                                .Empleado?.nombreCompleto
                                                        }
                                                    </div>

                                                </div>

                                                <div className="col-md-6">

                                                    <small className="text-muted d-block">
                                                        Fecha de Anulación
                                                    </small>

                                                    <div className="font-weight-bold">
                                                        {moment(
                                                            ventaSeleccionada
                                                                .ventanuladas[0]
                                                                .fechaHora
                                                        ).format(
                                                            "DD/MM/YYYY HH:mm"
                                                        )}
                                                    </div>

                                                </div>

                                                <div className="col-md-6">

                                                    <small className="text-muted d-block">
                                                        Estado
                                                    </small>

                                                    <span className="badge badge-danger">
                                                        ANULADA
                                                    </span>

                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                )}

                                {pagosValidos.length > 0 && !ventaSeleccionada?.ventanuladas?.length ? (
                                    ultimoPago ? (
                                        <ModalWizardBootstrap
                                            titulo={`Proceso de anulación y nuevo pago para venta #${ventaSeleccionada?.id || "..."
                                                }`}
                                            modalIsOpen={modalOpen2}
                                            setModalIsOpen={setModalOpen2}
                                            nombreBoton="Anular pago"
                                            estiloBoton="btn btn-warning mx-3"
                                            iconBoton="fas fa-exchange-alt mx-2"
                                            iconos={[
                                                "fas fa-ban",
                                                "fas fa-money-check",
                                                "fas fa-check-circle",
                                            ]}
                                            onFinish={confirmarAnulacionPago}
                                            pasos={[
                                                {
                                                    etiqueta: "Anulacion",
                                                    contenido: (
                                                        <>
                                                            {ventaSeleccionada?.ventanuladas?.length > 0 ? (
                                                                <div className="text-center">
                                                                    <p>Esta venta ya ha sido anulada.</p>
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    <div className="mb-3">
                                                                        <label className="form-label fw-bold">
                                                                            Motivo de anulación
                                                                        </label>
                                                                        <textarea
                                                                            className="form-control"
                                                                            rows="3"
                                                                            value={descripcionAnulacion2}
                                                                            onChange={(e) =>
                                                                                setDescripcionAnulacion2(e.target.value)
                                                                            }
                                                                        />
                                                                    </div>
                                                                </>
                                                            )}
                                                        </>
                                                    ),
                                                },
                                                {
                                                    etiqueta: "Nuevo Pago",
                                                    contenido: (
                                                        <>
                                                            <MetodosPagoDinamicos
                                                                efectivo={efectivo}
                                                                setEfectivo={setEfectivo}
                                                                montosPos={montosPos}
                                                                setMontosPos={setMontosPos}
                                                                referenciasPos={referenciasPos}
                                                                setReferenciasPos={setReferenciasPos}
                                                                erroresReferenciaPos={erroresReferenciaPos}
                                                                setErroresReferenciaPos={setErroresReferenciaPos}
                                                                montosTransferencia={montosTransferencia}
                                                                setMontosTransferencia={setMontosTransferencia}
                                                                referenciasTransferencia={referenciasTransferencia}
                                                                setReferenciasTransferencia={setReferenciasTransferencia}
                                                                erroresReferenciaTransferencia={erroresReferenciaTransferencia}
                                                                setErroresReferenciaTransferencia={setErroresReferenciaTransferencia}
                                                                pos={pos}
                                                                setPos={setPos}
                                                                transferencias={transferencias}
                                                                setTransferencias={setTransferencias}
                                                                formatoMoneda={formatoMoneda}
                                                                totalConRecargo={saldoAntesDelUltimoPago}
                                                                totalRecibido={totalRecibido}
                                                            />

                                                            <div className="alert alert-warning mt-3">
                                                                <i className="fas fa-info-circle mx-2"></i>
                                                                El saldo pendiente a pagar es de: <strong>{formatoMoneda(saldoAntesDelUltimoPago)}</strong>
                                                            </div>
                                                            <div className="alert alert-info">
                                                                <i className="fas fa-calculator mx-2"></i>
                                                                Total Recibido: <strong>{formatoMoneda(totalRecibido)}</strong> |
                                                                Cambio: <strong>{formatoMoneda(calcularCambio)}</strong>
                                                            </div>
                                                        </>
                                                    ),
                                                },
                                                {
                                                    etiqueta: "Confirmación",
                                                    contenido: (
                                                        <div className="text-center">
                                                            <i className="fas fa-check-circle fa-3x text-success mb-2" />
                                                            <p>¡Todo listo para un nuevo pago!</p>
                                                        </div>
                                                    ),
                                                },
                                            ]}
                                        />
                                    ) : null
                                ) : null}
                            </>
                        }
                    >
                        {ventaSeleccionada.ventadetallepedidos?.length > 0 ? (
                            <div className="container-fluid">
                                <div className="row justify-content-center">
                                    <div className="col-12">

                                        {/* ENCABEZADO */}
                                        <div className="card border-0 shadow-sm">

                                            <div className="card-header py-4">

                                                <div className="row mb-4">

                                                    <div className="col-md-8">

                                                        <h2 className="h3 mb-2 text-primary fw-bold">
                                                            Informe de Auditoría de Venta
                                                        </h2>

                                                        <p className="text-secondary mb-2">
                                                            Venta #{ventaSeleccionada.id}
                                                        </p>

                                                        <div>

                                                            {documentoInfo && (
                                                                <span
                                                                    className={`badge mr-2 ${documentoInfo.badge}`}
                                                                >
                                                                    {documentoInfo.tipo}: {documentoInfo.numero}
                                                                </span>
                                                            )}

                                                            {ventaSeleccionada.creditos?.[0] && (
                                                                <span className="badge bg-warning mr-2">
                                                                    Crédito #{ventaSeleccionada.creditos[0].id}
                                                                </span>
                                                            )}

                                                        </div>

                                                    </div>

                                                    <div className="col-md-4 text-md-right mt-3 mt-md-0">

                                                        <h4 className="mb-1 ">
                                                            Venta
                                                        </h4>

                                                        <p className="text-secondary mb-2">

                                                            Estado de la Venta

                                                        </p>

                                                        <span
                                                            className={`badge px-3 py-2 ${ventaSeleccionada.estado === "Completada"
                                                                ? "bg-success"
                                                                : ventaSeleccionada.estado === "Anulada"
                                                                    ? "bg-danger"
                                                                    : "bg-warning text-dark"
                                                                }`}
                                                        >
                                                            {ventaSeleccionada.estado}
                                                        </span>

                                                    </div>

                                                </div>

                                                <hr className="border-secondary opacity-50 my-4" />

                                                <div className="row">

                                                    {/* INFORMACIÓN DEL CLIENTE */}

                                                    <div className="col-md-6 text-md-left mt-4 mt-md-0">

                                                        <div className="row">
                                                            <div className="col-6 mb-2">
                                                                <small className="text-secondary d-block">
                                                                    Cliente
                                                                </small>


                                                                <strong>
                                                                    {ventaSeleccionada.Cliente?.ClienteEmpresas?.[0]?.nombre ||
                                                                        ventaSeleccionada.Cliente?.nombreCompleto ||
                                                                        "N/A"}
                                                                </strong>

                                                            </div>
                                                            <div className="col-6 mb-2">
                                                                <small className="text-secondary d-block">
                                                                    RTN
                                                                </small>


                                                                <strong>
                                                                    {ventaSeleccionada.rtn || "N/A"}
                                                                </strong>

                                                            </div>
                                                            <div className="col-6 mb-2">
                                                                <small className="text-secondary d-block">
                                                                    Tipo de Venta
                                                                </small>


                                                                <strong>
                                                                    {ventaSeleccionada.tipoVenta || "N/A"}
                                                                </strong>

                                                            </div>
                                                            <div className="col-6 mb-2">
                                                                <small className="text-secondary d-block">
                                                                    Vendedor
                                                                </small>


                                                                <strong>
                                                                    {ventaSeleccionada.Empleado?.nombreCompleto || "N/A"}
                                                                </strong>

                                                            </div>
                                                            <div className="col-6 mb-2">
                                                                <small className="text-secondary d-block">
                                                                    Caja
                                                                </small>

                                                                <strong>
                                                                    {ventaSeleccionada.caja?.nombre || "N/A"}
                                                                </strong>
                                                            </div>

                                                            <div className="col-6 mb-2">
                                                                <small className="text-secondary d-block">
                                                                    Dispositivo
                                                                </small>

                                                                <strong>
                                                                    {ventaSeleccionada.caja?.estacione?.dispositivo || "N/A"}
                                                                </strong>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    {/* INFORMACIÓN DEL DOCUMENTO */}

                                                    <div className="col-md-6 text-md-right mt-4 mt-md-0">

                                                        <div className="row">

                                                            <div className="col-6 mb-2">
                                                                <small className="text-secondary d-block">
                                                                    {documentoInfo
                                                                        ? `${documentoInfo.tipo}`
                                                                        : "Documento"}
                                                                </small>

                                                                <strong>
                                                                    {documentoInfo
                                                                        ? `#${documentoInfo.numero}`
                                                                        : "N/A"}
                                                                </strong>
                                                            </div>

                                                            <div className="col-6 mb-2">
                                                                <small className="text-secondary d-block">
                                                                    Pedido
                                                                </small>

                                                                <strong>
                                                                    #
                                                                    {ventaSeleccionada.ventapedidos?.[0]?.pedidoId || "N/A"}
                                                                </strong>
                                                            </div>

                                                            {ventaSeleccionada.creditos?.[0] && (
                                                                <>
                                                                    <div className="col-6 mb-2">
                                                                        <small className="text-secondary d-block">
                                                                            Estado Crédito
                                                                        </small>

                                                                        <strong
                                                                            className={
                                                                                ventaSeleccionada.creditos[0].estado === "Pendiente"
                                                                                    ? "text-warning"
                                                                                    : "text-success"
                                                                            }
                                                                        >
                                                                            {ventaSeleccionada.creditos[0].estado}
                                                                        </strong>
                                                                    </div>

                                                                    <div className="col-6 mb-2">
                                                                        <small className="text-secondary d-block">
                                                                            Días Mora
                                                                        </small>

                                                                        <strong
                                                                            className={
                                                                                ventaSeleccionada.creditos[0].diasMora > 0
                                                                                    ? "text-danger"
                                                                                    : "text-success"
                                                                            }
                                                                        >
                                                                            {ventaSeleccionada.creditos[0].diasMora}
                                                                        </strong>
                                                                    </div>

                                                                    <div className="col-6 mb-2">
                                                                        <small className="text-secondary d-block">
                                                                            Fecha Registro
                                                                        </small>

                                                                        <strong>
                                                                            {moment(
                                                                                ventaSeleccionada.createdAt
                                                                            ).format("DD/MM/YYYY")}
                                                                        </strong>
                                                                    </div>

                                                                    <div className="col-6 mb-2">
                                                                        <small className="text-secondary d-block">
                                                                            Vencimiento
                                                                        </small>

                                                                        <strong>
                                                                            {moment(
                                                                                ventaSeleccionada.creditos[0].fechaVencimiento
                                                                            ).format("DD/MM/YYYY")}
                                                                        </strong>
                                                                    </div>
                                                                </>
                                                            )}

                                                        </div>

                                                    </div>

                                                </div>
                                            </div>

                                            <div className="card-body">

                                                {(() => {

                                                    const totalVenta = ventaSeleccionada.ventadetallepedidos.reduce(
                                                        (sum, item) =>
                                                            sum +
                                                            item.cantidad * parseFloat(item.precio || 0),
                                                        0
                                                    );

                                                    const totalPagado =
                                                        ventaSeleccionada.pagoVenta
                                                            ?.filter(p => p.pago.estado !== "Anulada")
                                                            .reduce(
                                                                (sum, p) =>
                                                                    sum +
                                                                    parseFloat(
                                                                        p.pago.pago || 0
                                                                    ),
                                                                0
                                                            ) || 0;

                                                    const saldoPendiente = Math.max(
                                                        totalVenta - totalPagado,
                                                        0
                                                    );

                                                    return (
                                                        <>
                                                            {/* KPI */}

                                                            {/* PRODUCTOS */}
                                                            <div className="card shadow-sm mb-4">

                                                                <div className="card-header">
                                                                    <h5 className="mb-0 font-weight-bold">
                                                                        Detalle de Productos Vendidos
                                                                    </h5>
                                                                </div>

                                                                <div className="card-body p-0">

                                                                    <div className="table-responsive">

                                                                        <table className="table align-middle mb-0">

                                                                            <thead>

                                                                                <tr>

                                                                                    <th
                                                                                        className="border-top-0"
                                                                                        style={{ width: "60px" }}
                                                                                    >
                                                                                        #
                                                                                    </th>

                                                                                    <th className="border-top-0">
                                                                                        Descripción
                                                                                    </th>

                                                                                    <th
                                                                                        className="border-top-0 text-right"
                                                                                        style={{ width: "120px" }}
                                                                                    >
                                                                                        Cantidad
                                                                                    </th>

                                                                                    <th
                                                                                        className="border-top-0 text-right"
                                                                                        style={{ width: "150px" }}
                                                                                    >
                                                                                        Precio Unitario
                                                                                    </th>

                                                                                    <th
                                                                                        className="border-top-0 text-right"
                                                                                        style={{ width: "150px" }}
                                                                                    >
                                                                                        Descuento
                                                                                    </th>

                                                                                    <th
                                                                                        className="border-top-0 text-right"
                                                                                        style={{ width: "180px" }}
                                                                                    >
                                                                                        Subtotal
                                                                                    </th>

                                                                                </tr>

                                                                            </thead>

                                                                            <tbody>

                                                                                {ventaSeleccionada.ventadetallepedidos.map(
                                                                                    (detalle, index) => {

                                                                                        const subtotal =
                                                                                            detalle.cantidad *
                                                                                            parseFloat(
                                                                                                detalle.precio || 0
                                                                                            );

                                                                                        return (
                                                                                            <tr key={index}>

                                                                                                <td>
                                                                                                    {index + 1}
                                                                                                </td>

                                                                                                <td>

                                                                                                    <div className="mb-2">

                                                                                                        <span className="badge badge-secondary mr-1">
                                                                                                            ID {detalle.producto?.id}
                                                                                                        </span>

                                                                                                        <span className="badge badge-dark">
                                                                                                            {detalle.producto?.codigo}
                                                                                                        </span>

                                                                                                    </div>

                                                                                                    <p className="mb-0 font-weight-bold">
                                                                                                        {detalle.producto?.nombre}
                                                                                                    </p>

                                                                                                    {detalle.tipoImpuesto && (
                                                                                                        <small className="text-muted">
                                                                                                            Impuesto: {detalle.tipoImpuesto}
                                                                                                        </small>
                                                                                                    )}

                                                                                                </td>

                                                                                                <td className="text-right">
                                                                                                    {detalle.cantidad}
                                                                                                </td>

                                                                                                <td className="text-right">
                                                                                                    {formatoMoneda(
                                                                                                        detalle.precio
                                                                                                    )}
                                                                                                </td>

                                                                                                <td className="text-right text-muted">
                                                                                                    {formatoMoneda(
                                                                                                        detalle.descuento
                                                                                                    )}
                                                                                                </td>

                                                                                                <td className="text-right font-weight-bold">
                                                                                                    {formatoMoneda(
                                                                                                        subtotal
                                                                                                    )}
                                                                                                </td>

                                                                                            </tr>
                                                                                        );
                                                                                    }
                                                                                )}

                                                                            </tbody>

                                                                            <tfoot>

                                                                                <tr>

                                                                                    <td
                                                                                        colSpan="5"
                                                                                        className="text-right font-weight-bold border-top"
                                                                                    >
                                                                                        Subtotal
                                                                                    </td>

                                                                                    <td className="text-right border-top">
                                                                                        {formatoMoneda(
                                                                                            ventaSeleccionada.subtotal
                                                                                        )}
                                                                                    </td>

                                                                                </tr>

                                                                                <tr>

                                                                                    <td
                                                                                        colSpan="5"
                                                                                        className="text-right font-weight-bold"
                                                                                    >
                                                                                        ISV 15%
                                                                                    </td>

                                                                                    <td className="text-right">
                                                                                        {formatoMoneda(
                                                                                            ventaSeleccionada.impuesto15
                                                                                        )}
                                                                                    </td>

                                                                                </tr>

                                                                                {Number(
                                                                                    ventaSeleccionada.impuesto18 || 0
                                                                                ) > 0 && (

                                                                                        <tr>

                                                                                            <td
                                                                                                colSpan="5"
                                                                                                className="text-right font-weight-bold"
                                                                                            >
                                                                                                ISV 18%
                                                                                            </td>

                                                                                            <td className="text-right">
                                                                                                {formatoMoneda(
                                                                                                    ventaSeleccionada.impuesto18
                                                                                                )}
                                                                                            </td>

                                                                                        </tr>

                                                                                    )}

                                                                                {Number(
                                                                                    ventaSeleccionada.exento || 0
                                                                                ) > 0 && (

                                                                                        <tr>

                                                                                            <td
                                                                                                colSpan="5"
                                                                                                className="text-right font-weight-bold"
                                                                                            >
                                                                                                Exento
                                                                                            </td>

                                                                                            <td className="text-right">
                                                                                                {formatoMoneda(
                                                                                                    ventaSeleccionada.exento
                                                                                                )}
                                                                                            </td>

                                                                                        </tr>

                                                                                    )}

                                                                                {Number(
                                                                                    ventaSeleccionada.exonerado || 0
                                                                                ) > 0 && (

                                                                                        <tr>

                                                                                            <td
                                                                                                colSpan="5"
                                                                                                className="text-right font-weight-bold"
                                                                                            >
                                                                                                Exonerado
                                                                                            </td>

                                                                                            <td className="text-right">
                                                                                                {formatoMoneda(
                                                                                                    ventaSeleccionada.exonerado
                                                                                                )}
                                                                                            </td>

                                                                                        </tr>

                                                                                    )}

                                                                                <tr>

                                                                                    <td
                                                                                        colSpan="5"
                                                                                        className="text-right font-weight-bold h6 border-top"
                                                                                    >
                                                                                        TOTAL FACTURADO
                                                                                    </td>

                                                                                    <td className="text-right font-weight-bold h6 border-top text-primary">
                                                                                        {formatoMoneda(
                                                                                            ventaSeleccionada.totalVenta
                                                                                        )}
                                                                                    </td>

                                                                                </tr>

                                                                            </tfoot>

                                                                        </table>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <div className="row">

                                                                {/* CONCILIACION */}
                                                                <div className="col-lg-4 mb-4">

                                                                    <div className="card shadow-sm border-primary">

                                                                        <div className="card-header bg-primary text-white">
                                                                            Conciliación Financiera
                                                                        </div>

                                                                        <div className="card-body">

                                                                            <div className="d-flex justify-content-between mb-3">
                                                                                <span>
                                                                                    Total Facturado
                                                                                </span>

                                                                                <strong>
                                                                                    {formatoMoneda(
                                                                                        totalVenta
                                                                                    )}
                                                                                </strong>
                                                                            </div>

                                                                            <div className="d-flex justify-content-between mb-3">
                                                                                <span>
                                                                                    Total Pagado
                                                                                </span>

                                                                                <strong className="text-success">
                                                                                    {formatoMoneda(
                                                                                        totalPagado
                                                                                    )}
                                                                                </strong>
                                                                            </div>

                                                                            <hr />

                                                                            <div className="d-flex justify-content-between">

                                                                                <span className="fw-bold">
                                                                                    Saldo Pendiente
                                                                                </span>

                                                                                <span
                                                                                    className={`fw-bold fs-4 ${saldoPendiente > 0
                                                                                        ? "text-danger"
                                                                                        : "text-success"
                                                                                        }`}
                                                                                >
                                                                                    {formatoMoneda(
                                                                                        saldoPendiente
                                                                                    )}
                                                                                </span>

                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    {/* DATOS AUDITORIA */}

                                                                    <div className="card shadow-sm mt-3">

                                                                        <div className="card-header bg-info text-white">
                                                                            Información de Auditoría
                                                                        </div>

                                                                        <div className="card-body">

                                                                            <p>
                                                                                <strong>Productos:</strong>{" "}
                                                                                {
                                                                                    ventaSeleccionada
                                                                                        .ventadetallepedidos
                                                                                        .length
                                                                                }
                                                                            </p>

                                                                            <p className="mb-0">
                                                                                <strong>
                                                                                    Registros de pago:
                                                                                </strong>{" "}
                                                                                {
                                                                                    ventaSeleccionada
                                                                                        .pagoVenta
                                                                                        ?.length
                                                                                }
                                                                            </p>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                {/* PAGOS */}
                                                                <div className="col-lg-8">

                                                                    <div className="card shadow-sm">

                                                                        <div className="card-header">
                                                                            <h5 className="mb-0 font-weight-bold">
                                                                                Libro Auxiliar de Pagos
                                                                            </h5>
                                                                        </div>

                                                                        <div className="card-body p-0">

                                                                            <div className="table-responsive">

                                                                                <table className="table align-middle mb-0">

                                                                                    <thead>

                                                                                        <tr>

                                                                                            <th
                                                                                                className="border-top-0"
                                                                                                style={{ width: "100px" }}
                                                                                            >
                                                                                                Pago
                                                                                            </th>

                                                                                            <th
                                                                                                className="border-top-0"
                                                                                                style={{ width: "170px" }}
                                                                                            >
                                                                                                Fecha
                                                                                            </th>

                                                                                            <th className="border-top-0">
                                                                                                Método
                                                                                            </th>

                                                                                            <th
                                                                                                className="border-top-0 text-right"
                                                                                                style={{ width: "140px" }}
                                                                                            >
                                                                                                Recibido
                                                                                            </th>

                                                                                            <th
                                                                                                className="border-top-0 text-right"
                                                                                                style={{ width: "140px" }}
                                                                                            >
                                                                                                Cambio
                                                                                            </th>

                                                                                            <th
                                                                                                className="border-top-0 text-right"
                                                                                                style={{ width: "140px" }}
                                                                                            >
                                                                                                Aplicado
                                                                                            </th>

                                                                                        </tr>

                                                                                    </thead>

                                                                                    <tbody>

                                                                                        {todasLasLineasDePago.length > 0 ? (

                                                                                            todasLasLineasDePago.map(
                                                                                                linea => (

                                                                                                    <tr key={linea.key}>

                                                                                                        <td>

                                                                                                            <p className="mb-0 font-weight-bold">
                                                                                                                #{linea.pagoId}
                                                                                                            </p>

                                                                                                            <small className="text-muted">
                                                                                                                {linea.documento}
                                                                                                            </small>

                                                                                                        </td>

                                                                                                        <td>

                                                                                                            <div>
                                                                                                                {moment(
                                                                                                                    linea.fecha
                                                                                                                ).format(
                                                                                                                    "DD/MM/YYYY"
                                                                                                                )}
                                                                                                            </div>

                                                                                                            <small className="text-muted">
                                                                                                                {moment(
                                                                                                                    linea.fecha
                                                                                                                ).format(
                                                                                                                    "HH:mm"
                                                                                                                )}
                                                                                                            </small>

                                                                                                        </td>

                                                                                                        <td>

                                                                                                            <span
                                                                                                                className={`badge ${linea.metodo === "Efectivo"
                                                                                                                    ? "badge-success"
                                                                                                                    : linea.metodo === "Tarjeta"
                                                                                                                        ? "badge-info"
                                                                                                                        : linea.metodo === "Transferencia"
                                                                                                                            ? "badge-primary"
                                                                                                                            : "badge-secondary"
                                                                                                                    }`}
                                                                                                            >
                                                                                                                {linea.metodo}
                                                                                                            </span>

                                                                                                        </td>

                                                                                                        <td className="text-right font-weight-bold">

                                                                                                            {formatoMoneda(
                                                                                                                linea.monto
                                                                                                            )}

                                                                                                        </td>

                                                                                                        <td className="text-right text-danger">

                                                                                                            {Number(
                                                                                                                linea.cambio || 0
                                                                                                            ) > 0
                                                                                                                ? formatoMoneda(
                                                                                                                    linea.cambio
                                                                                                                )
                                                                                                                : "-"}

                                                                                                        </td>

                                                                                                        <td className="text-right font-weight-bold text-success">

                                                                                                            {formatoMoneda(
                                                                                                                linea.aplicado
                                                                                                            )}

                                                                                                        </td>

                                                                                                    </tr>

                                                                                                )
                                                                                            )

                                                                                        ) : (

                                                                                            <tr>

                                                                                                <td
                                                                                                    colSpan="6"
                                                                                                    className="text-center text-muted py-4"
                                                                                                >
                                                                                                    No existen pagos registrados.
                                                                                                </td>

                                                                                            </tr>

                                                                                        )}

                                                                                    </tbody>

                                                                                    <tfoot>

                                                                                        <tr>

                                                                                            <td
                                                                                                colSpan="5"
                                                                                                className="text-right font-weight-bold border-top"
                                                                                            >
                                                                                                Total Aplicado
                                                                                            </td>

                                                                                            <td className="text-right font-weight-bold text-success border-top">

                                                                                                {formatoMoneda(totalPagado)}

                                                                                            </td>

                                                                                        </tr>

                                                                                    </tfoot>

                                                                                </table>

                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            {/* ANULADOS */}

                                                            {ventaSeleccionada.pagoVenta?.filter(
                                                                p => p.pago.estado === "Anulada"
                                                            ).length > 0 && (

                                                                    <div className="card shadow-sm mt-4 border-danger">

                                                                        <div className="card-header">

                                                                            <div className="d-flex justify-content-between align-items-center">

                                                                                <div>

                                                                                    <h5 className="mb-0 text-danger font-weight-bold">
                                                                                        Pagos Anulados
                                                                                    </h5>

                                                                                    <small className="text-muted">
                                                                                        Movimientos excluidos de la conciliación financiera y del cálculo del saldo pendiente.
                                                                                    </small>

                                                                                </div>

                                                                                <span className="badge badge-danger">
                                                                                    {
                                                                                        ventaSeleccionada.pagoVenta.filter(
                                                                                            p => p.pago.estado === "Anulada"
                                                                                        ).length
                                                                                    } Anulado(s)
                                                                                </span>

                                                                            </div>

                                                                        </div>

                                                                        <div className="card-body p-0">

                                                                            <div className="table-responsive">

                                                                                <table className="table align-middle mb-0">

                                                                                    <thead>

                                                                                        <tr>

                                                                                            <th className="border-top-0">
                                                                                                Pago
                                                                                            </th>

                                                                                            <th className="border-top-0">
                                                                                                Fecha
                                                                                            </th>

                                                                                            <th className="border-top-0">
                                                                                                Motivo
                                                                                            </th>

                                                                                            <th className="border-top-0">
                                                                                                Método
                                                                                            </th>

                                                                                            <th
                                                                                                className="border-top-0 text-right"
                                                                                                style={{ width: "180px" }}
                                                                                            >
                                                                                                Monto
                                                                                            </th>

                                                                                        </tr>

                                                                                    </thead>

                                                                                    <tbody>

                                                                                        {ventaSeleccionada.pagoVenta
                                                                                            .filter(
                                                                                                p =>
                                                                                                    p.pago.estado ===
                                                                                                    "Anulada"
                                                                                            )
                                                                                            .map(p => (

                                                                                                <tr key={p.pago.id}>

                                                                                                    <td>

                                                                                                        <p className="mb-0 font-weight-bold">
                                                                                                            #{p.pago.id}
                                                                                                        </p>

                                                                                                        <small className="text-danger">
                                                                                                            Anulado
                                                                                                        </small>

                                                                                                    </td>

                                                                                                    <td>

                                                                                                        <div>
                                                                                                            {moment(
                                                                                                                p.pago.fecha
                                                                                                            ).format(
                                                                                                                "DD/MM/YYYY"
                                                                                                            )}
                                                                                                        </div>

                                                                                                        <small className="text-muted">
                                                                                                            {moment(
                                                                                                                p.pago.fecha
                                                                                                            ).format(
                                                                                                                "HH:mm"
                                                                                                            )}
                                                                                                        </small>

                                                                                                    </td>

                                                                                                    <td>

                                                                                                        <p className="mb-0">
                                                                                                            {p.pago.pagoanulados[0].descripcion || "Sin motivo"}
                                                                                                        </p>
                                                                                                        <small className="text-muted">
                                                                                                            {p.pago.pagoanulados[0].Empleado?.nombreCompleto || "Desconocido"}
                                                                                                        </small>

                                                                                                    </td>

                                                                                                    <td>

                                                                                                        {p.pago.pagoefectivos?.length > 0 && (
                                                                                                            <div className="d-flex justify-content-between align-items-center mb-1">

                                                                                                                <span>
                                                                                                                    <span className="badge badge-success mr-2">
                                                                                                                        Efectivo
                                                                                                                    </span>
                                                                                                                </span>

                                                                                                                <strong>
                                                                                                                    {formatoMoneda(
                                                                                                                        p.pago.pagoefectivos.reduce(
                                                                                                                            (s, e) => s + Number(e.monto || 0),
                                                                                                                            0
                                                                                                                        )
                                                                                                                    )}
                                                                                                                </strong>

                                                                                                            </div>
                                                                                                        )}

                                                                                                        {p.pago.pagotarjeta?.length > 0 && (
                                                                                                            <div className="d-flex justify-content-between align-items-center mb-1">

                                                                                                                <span>
                                                                                                                    <span className="badge badge-info mr-2">
                                                                                                                        POS
                                                                                                                    </span>
                                                                                                                </span>

                                                                                                                <strong>
                                                                                                                    {formatoMoneda(
                                                                                                                        p.pago.pagotarjeta.reduce(
                                                                                                                            (s, e) => s + Number(e.monto || 0),
                                                                                                                            0
                                                                                                                        )
                                                                                                                    )}
                                                                                                                </strong>

                                                                                                            </div>
                                                                                                        )}

                                                                                                        {p.pago.pagotransferencia?.length > 0 && (
                                                                                                            <div className="d-flex justify-content-between align-items-center mb-1">

                                                                                                                <span>
                                                                                                                    <span className="badge badge-primary mr-2">
                                                                                                                        Transferencia
                                                                                                                    </span>
                                                                                                                </span>

                                                                                                                <strong>
                                                                                                                    {formatoMoneda(
                                                                                                                        p.pago.pagotransferencia.reduce(
                                                                                                                            (s, e) => s + Number(e.monto || 0),
                                                                                                                            0
                                                                                                                        )
                                                                                                                    )}
                                                                                                                </strong>

                                                                                                            </div>
                                                                                                        )}

                                                                                                        {(Number(p.pago.recibido || 0) >
                                                                                                            Number(p.pago.pago || 0)) && (

                                                                                                                <>
                                                                                                                    <hr className="my-1" />

                                                                                                                    <div className="d-flex justify-content-between align-items-center">

                                                                                                                        <span className="text-danger">
                                                                                                                            <i className="fas fa-undo-alt mr-1"></i>
                                                                                                                            Cambio
                                                                                                                        </span>

                                                                                                                        <strong className="text-danger">
                                                                                                                            {formatoMoneda(
                                                                                                                                Number(p.pago.recibido || 0) -
                                                                                                                                Number(p.pago.pago || 0)
                                                                                                                            )}
                                                                                                                        </strong>

                                                                                                                    </div>
                                                                                                                </>
                                                                                                            )}

                                                                                                    </td>

                                                                                                    <td className="text-right font-weight-bold text-danger">

                                                                                                        {formatoMoneda(
                                                                                                            p.pago.pago
                                                                                                        )}

                                                                                                    </td>

                                                                                                </tr>

                                                                                            ))}

                                                                                    </tbody>

                                                                                    <tfoot>

                                                                                        <tr>

                                                                                            <td
                                                                                                colSpan="3"
                                                                                                className="text-right font-weight-bold border-top"
                                                                                            >
                                                                                                Total Anulado
                                                                                            </td>

                                                                                            <td className="text-right font-weight-bold text-danger border-top">

                                                                                                {formatoMoneda(
                                                                                                    ventaSeleccionada.pagoVenta
                                                                                                        .filter(
                                                                                                            p =>
                                                                                                                p.pago.estado ===
                                                                                                                "Anulada"
                                                                                                        )
                                                                                                        .reduce(
                                                                                                            (sum, p) =>
                                                                                                                sum +
                                                                                                                Number(
                                                                                                                    p.pago.pago ||
                                                                                                                    0
                                                                                                                ),
                                                                                                            0
                                                                                                        )
                                                                                                )}

                                                                                            </td>

                                                                                        </tr>

                                                                                    </tfoot>

                                                                                </table>

                                                                            </div>

                                                                        </div>

                                                                    </div>
                                                                )}
                                                        </>
                                                    );
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="alert alert-info text-center py-4 shadow-sm" role="alert">
                                <h5 className="mb-0">ℹ️ No hay detalles o movimientos de pago registrados para esta venta.</h5>
                            </div>
                        )}
                    </Card>
                </div>
            )}
        </Page>
    );
};

export default HomeEditarVentas;